<div class="dtf-accountdetails">
<style>
.bardashboard {
  padding: 20px;
  background-color: #f0f4f7;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.chart-container {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  flex-wrap: wrap;
  height: auto;
  box-sizing: border-box;
}

.chart-info {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
}

.chart-box {
  width: 48%;
  padding: 15px;
  border-radius: 10px;
  background-color: white;
  border: 1px solid #ddd;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  flex-grow: 0 !important;
}

.chart-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 10px;
}

.chart-box p {
  font-size: 14px;
  color: #333;
  margin: 0;
}

.donut-chart-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

.chart-number {
  font-size: 24px;
  font-weight: bold;
  color: #333;
  margin: 5px 0;
}

#donut-chart {
  width: 100%;
  max-width: 280px;
  height: auto;
  margin: 0 auto;
  display: block;
  margin-bottom: 5px;
}

.chart-labels {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 20px;
  text-align: center;
  margin-top: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #333;
  padding: 10px;
  box-sizing: border-box;
  flex-grow: 0;
  margin-bottom: 0;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* ✅ NEW: Header label layout (3 lines) */
.donut-header-row {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 10px;
}

.donut-header-line {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 14px;
  justify-content: flex-start;
  align-items: center; /* Align vertically */
}

.donut-header-line.spaced {
  justify-content: space-between;
}

.donut-header-item {
  display: flex;
  align-items: center;
  gap: 8px;
}


.square-box {
  width: 20px;
  height: 20px;
  background-color: #cce1e6;
  border: 2px solid #cce1e6;
  display: inline-block;
  margin-right: 8px;
  border-radius: 4px;
}

.square-box1 {
  width: 20px;
  height: 20px;
  background-color: #5097ab;
  border: 2px solid #5097ab;
  display: inline-block;
  margin-right: 8px;
  border-radius: 4px;
}

/* Bar chart styles */
.chart-box.bar-chart-box {
  min-height: 400px;
  height: auto;
  flex-grow: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  position: relative;
  overflow: visible;
}

#barChart {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  min-height: 300px;
  position: relative;
}

#barChart svg {
  width: 100% !important;
  height: 100% !important;
  display: block;
}

.bar-chart-legend {
  font-size: 12px;
  fill: #333;
}

/* ✅ Mobile-specific adjustments only */
@media (max-width: 768px) {
  .donut-chart-box {
    padding: 10px;
  }

  .chart-info {
    padding: 0 5px;
    flex-direction: column;
    gap: 10px;
  }

  .chart-title {
    font-size: 16px;
  }

  .chart-labels {
    font-size: 14px;
    flex-direction: column;
  }

  .chart-box {
    padding: 5px;
    width: 100% !important;
    flex-grow: 0 !important;
  }

  .chart-info > .chart-box {
    width: 100% !important;
  }

  .chart-container {
    flex-direction: column;
    gap: 20px;
  }

  .chart-container > .chart-box {
    width: 100% !important;
    flex-grow: 0 !important;
  }

  .square-box,
  .square-box1 {
    width: 16px;
    height: 16px;
  }

  .chart-box.bar-chart-box {
    min-height: 600px !important;
    padding-left: 10px;
    padding-right: 10px;
  }

  #barChart {
    min-height: 400px;
  }
}
</style>


 <div class="container_dashboard">
    <h4 class="dtfbrochures__header_dark">Dynamic Financing</h4>

    <div class="bardashboard">
      <!-- New Dashboard Section -->
      <div class="chart-container">
        <!-- Donut Chart Box -->
        <div class="chart-box">
          <div class="donut-header-row">
            <!-- Line 1 -->
            <div class="donut-header-line spaced">
              <div class="donut-header-item">
                <span><b>Statement Month:</b></span>
                <mat-form-field appearance="outline">
                  <mat-select
                    name="statementPeriod"
                    placeholder="{{ 'Invoice.StatePeriod' | translate }}"
                    [(ngModel)]="selectedMonth"
                    (selectionChange)="onStatementChange()"
                  >
                    <mat-option *ngFor="let month of statementMonths" [value]="month">
                      {{ month.display }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>


            <!-- Line 2 -->
            <div class="donut-header-line spaced">
              <label><b>Contract: </b>{{this.accountNumber}}</label>
              <label><b>Charge Per Mile: </b>${{this.mileageRate}}</label>
            </div>
          </div>


        <div class="donut-chart-box" #donutChartContainer>
          <h2 class="chart-number" matTooltip="Base Payment">${{ this.totalOverage | number:'1.2-2' }}</h2>
          <div #donutChart id="donut-chart"></div>
          <h2 class="chart-number" matTooltip="Mileage Fee">${{ this.totalRental | number:'1.2-2' }}</h2>
        </div>

          <div class="chart-labels">
            <div class="legend-item">
              <div class="square-box1"></div>
              <label><b>Base:</b> {{ this.mileagePercentage }}</label>
            </div>
            <div class="legend-item">
              <div class="square-box"></div>
              <label><b>Mileage Fee:</b> {{ this.baseFeePercentage }}</label>
            </div>
          </div>
          <div class="chart-info">
            <div class="chart-box">
              <h3 class="chart-title">Carry Over Mileage</h3>
              <p>{{this.totalPrevUnusedAllowance}}</p>
            </div>

            <div class="chart-box">
              <h3 class="chart-title">Miles Available to Rebate</h3>
              <p>{{this.totalMilesAvailableForRebating}}</p>
            </div>
          </div>
        </div>

        <div class="chart-box bar-chart-box">
          <h3 class="chart-title">Statement History</h3>
          <div #barChart style="width: 100%; height: 100%;"></div>
        </div>
  </div>
</div>


  <!-- <div class="row"> -->
  <!-- <div class="accountflex">
    <h1 class="mercedes-me-login__column-headline2">{{ 'AccountDetails.Contracts' | translate }}</h1>
    <mat-form-field class="example-form-field" appearance="outline">
      <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
      <input matInput  (keyup)="applyFilter($event)" placeholder="Contract Number or Status" #input type="text" [(ngModel)]="value">
      <img matSuffix class="example-form-img"src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
    </mat-form-field>
  </div> -->
  
<!--Mat Table for US / CA-->
<mat-table
[dataSource]="dataSource" multiTemplateDataRows
class="mat-elevation-z8" matSort>
<!--US/EN Table loading-->
<ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast">
<mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center;" [matTooltip]="column.tooltip || null" [matTooltipDisabled]="!column.tooltip" matTooltipPosition="above">
  <div *ngIf="!isFrench"> {{column.display}}</div>
  <div *ngIf="isFrench"> {{column.displayFR}}</div>
</mat-header-cell>
<mat-cell *matCellDef="let element" style="justify-content: center;">
  <span class="mobile-label">
    <div *ngIf="!isFrench"> {{column.display}} :</div>
    <div *ngIf="isFrench"> {{column.displayFR}} :</div>
   </span>
   <div *ngIf="column.dispFormat=='vin'"> <!--Formats Currency Columns-->
    {{element.dynamicIdentity.vin}}
  </div>
  <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
    {{element[column.name] | currency:'USD':true:'1.2-2'}}
  </div>
  <div *ngIf="column.dispFormat=='none'"> 
  </div>
    <!-- <div *ngIf="column.dispFormat=='alert'"> 
      <mat-icon
       *ngIf="isReadingMissing(element.currMileageReading) || isReadingMissing(element.currReadingDate)"
        color="warn"
        matTooltip="Current Reading or Reading Date is missing"
      >
        error_outline
      </mat-icon>
  </div> -->
  <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
    <mat-icon *ngIf="element.newAcctAdded">
      <img matSuffix class="example-form-img" src="static/assets/img/dtf-assets/images/DTF_Icons/NewFlag.png">
    </mat-icon>
    {{element[column.name]}}
  </div>
  <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
    {{element[column.name]}}
  </div>
  <div *ngIf="column.dispFormat=='numbers'">
    <!--Formats String Columns-->
  {{ element[column.name] | number:'1.0-0' }}
  </div>
  <div *ngIf="column.dispFormat=='currPeriodOverUnder'">
 <div
    [ngStyle]="{
      'background-color': getAllowanceStatus(element[column.name]) === 'over' ? '#f1b644' : '#78adbe',
      'color': 'white',
      'padding': '4px 8px',
      'border-radius': '4px',
      'text-align': 'center',
      'font-weight': 'bold',
      'display': 'inline-block',
      'min-width': '120px'
    }">
    {{ getAllowanceStatus(element[column.name]) === 'over' ? 'Over allowance' : 'Under allowance' }}
  </div>
</div>
  <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
    {{element[column.name] | date:'MM/dd/yyyy'}}
  </div>
  <!-- <mat-icon *ngIf="isLast">&nbsp;{{element == dynamicAddendumRes ? 'expand_less' : 'expand_more'}}</mat-icon> -->
  <div *ngIf="isLast">
      <mat-icon
       *ngIf="isReadingMissing(element.odometerReading) || isReadingMissing(element.odometerReadingDateNK)"
        color="warn"
        matTooltip="Current Reading or Reading Date is missing"
      >
        error_outline
      </mat-icon>

      <button mat-icon-button (click)="openDialog(element.dynamicIdentity.vin)" [matMenuTriggerFor]="menu">
        <mat-icon>more_horiz</mat-icon>
      </button>
  </div>
</mat-cell>
</ng-container>

<!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
<ng-container matColumnDef="dynamicAddendumRes">
<mat-cell class="example-element-detailed-row" mat-cell *matCellDef="let element"
  [attr.colspan]="displayedColumns.length">
</mat-cell>
</ng-container>

<mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
<mat-row *matRowDef="let element; columns: displayedColumns;"
class="example-element-row"
[class.example-expanded-row]="dynamicAddendumRes === element"
(click)="dynamicAddendumRes = dynamicAddendumRes === element ? null : element">
</mat-row>
<mat-row *matRowDef="let row; columns: ['dynamicAddendumRes']" class="example-detail-row"></mat-row>

<!-- Row shown when there is no matching data. -->
<!-- <tr class="mat-row" *matNoDataRow>
<td class="mat-cell" colspan="4" *ngIf="!isFrench">No data matching the filter "{{input.value}}"</td>
<td class="mat-cell" colspan="4" *ngIf="isFrench">Aucune donnée correspondant au filtre "{{input.value}}"</td>
</tr> -->

</mat-table>

 <!-- </div> -->
</div>
<mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
<footer id="mbfs-footer">
<div role="contentinfo">
  <div class="mbfs-copyright">
    <p class="paragraph2">
         This data is for informational purposes related to mileage usage only and does not reflect all fees and charges that may appear on your monthly invoice.
    </p>
  </div>
</div>
</footer>
<br>
<button style="margin-left: 8%;"  type="submit"(click)="backstep()" class="mbfs-button">{{'LoginModal.back' | translate}}</button>
<br>
<p></p>

</div>